import React, { useEffect } from 'react';
import { ManageOrganisation } from './ManageOrganisation';
import { useResetOrganisationState } from '../../store';

export const CreateOrganisation: React.FC = () => {
  const resetState = useResetOrganisationState();

  useEffect(() => {
    resetState();
  }, [resetState]);

  return <ManageOrganisation />;
};
